export class FindAdminInformationResult {
    informationNo = -1;
    weight = false;
    isResponseRequired = false;
    isAnswered = false;
    startAt = "";
    endAt = "";
    target = -1;
    targetName = "";
    subject = "";
    isPastEndAt = false;
}
